<template lang="html">

  <section class="contenedor-tabla" :style="styles.colorBasic">

    <div class="contenedor-opciones row-between">

      <div class="container-title-anio">
        <h2 class="ficha-title" :style="styles.colorBasic" v-html="'Listado de prácticas'"></h2>
        <div class="contenedor-input cont-anio" v-if="aniosAcademicos && $route.name == 'tutorados'">
          <label for="">Año académico:</label>
          <div class="contenedor-input cont-anio-select">
            <select name="tutor" v-model="idAnioAcademicoHistorico" @change="anioAcademicoHistoricoChange">
              <option v-for="(el, key) in aniosAcademicos" :value="el.clave">{{ el.descripcion }}
              </option>
            </select>
          </div>
        </div>
    </div>

    <div class="row-end">
      <a class="option-table column-center" v-if="!!dataSelected && dataSelected.length != 0">
        <i class="column row-between ais" @click="exportExcel">
          <excel></excel>
        </i>
        <span @click="exportExcel">Descargar</span>
      </a>
      <a class="option-table column-center">
        <i class="column row-between ais" @click="showColumnasSetter = !showColumnasSetter">
          <columnas></columnas>
        </i>
        <span @click="showColumnasSetter = !showColumnasSetter">Columnas</span>
        <column-setter v-if="showColumnasSetter" :columns="encabezados" @change="setColumnas"
          @cerrar="showColumnasSetter = false"></column-setter>
      </a>


    </div>

    </div>
    <template v-if="loading">
      <div class="loader" id="loader"></div>
      <p class="loader-text">CARGANDO...</p>
    </template>
    <template v-else>
      <div class="scroll-table">

        <div class="contenedor-tabla" :type="$route.name" v-if="!!dataSelected">


          <template v-if="dataSelected.length > 0">
            <v-client-table :data="dataSelected" :columns="columns" :options="options" @row-click='open'>
              <span class="checkbox-cell row-start" slot="checkbox" slot-scope="{ row }">

                <figure class="indicador-status" :status="row.idEstadoValidacion" :title="row.estadoValidacion">
                </figure>

                <template v-if="!!row">
                  <fav :data="row"></fav>
                </template>

              </span>
              <span slot="fechaAlta" slot-scope="{row}">
                {{ row.fechaAlta | parsedate }}
              </span>
              <span class="action-cell row-start" slot="actions" slot-scope="{ row }">
                <router-link :to="linkBack + row.idOferta" class="to-ficha"
                  v-if="$route.name == 'ofertas-practicas-tutor'">
                  <next></next>
                </router-link>
                <router-link v-else :to="linkBack + row.idPractica" class="to-ficha">
                  <next></next>
                </router-link>
              </span>
            </v-client-table>
          </template>

          <template v-else>
            NO HAY DATOS
          </template>

        </div>

        <loading v-else></loading>

      </div>
    </template>

  </section>

</template>

<script lang="js">

import { ClientTable, Event } from 'vue-tables-2';

import Vue from 'vue';

Vue.use(ClientTable);

import daterangepicker from 'daterangepicker';

window.moment = require('moment');

import router from '@/router';

import { mapGetters, mapActions } from 'vuex';

import columnSetter from '@/components/parts/column-setter';

import next from '@/components/parts/icons/next';
import excel from '@/components/parts/icons/excel';
import columnas from '@/components/parts/icons/columnas';

import fav from '@/components/parts/fav';

import loading from '@/components/parts/loading';


import XLSX from 'xlsx';

export default {
  name: 'contenedor-tabla',
  props: [],
  mounted() {
    this.setColumnas();
    if (this.aniosAcademicos) {
      this.setListadoAniosAcademicos();
    }
  },
  methods: {
    setColumnas() {

      let alwaysActive = ['actions', 'checkbox'];
      this.encabezados = this.getEncabezados[this.$route.name];

      // /SETTING DE LOS NOMBRE DE LAS COLUMNAS
      let columnas = (!!this.encabezados) ? Object.entries(this.encabezados) : [];

      let visibles = new Object();

      this.columns = ['checkbox'];
      this.columsExcel = Object.assign({}, this.columns)
      columnas.forEach(e => {
        if (e[1].visible) {
          visibles[e[0]] = e[1].nombre;
          this.columns.push(e[0])
          if (this.columsExcel[e[0]] == null) {
            this.columsExcel[e[0]] = []
          }
          this.columsExcel[e[0]] = e[1].nombre
          this.options.columnsClasses[e[0]] = '-' + e[0]
        }
      });
      delete this.columsExcel['0']
      alwaysActive.forEach(e => {
        visibles[e] = '';
      })

      this.columns.push('actions');
      this.options.headings = visibles;


    },
    toggleAllChecks: function () {
      if (this.selected.length > 0) {
        this.selected = {};
      }

    },
    open: function ({ row }) {


      if (event.target.tagName == "TD") {

        if (!this.linkBack.includes("undefined")) {
          if (this.$route.name == 'aprobaciones') {
            router.push(this.linkBack + row.urlAcceso)
          }
          else if (this.$route.name == 'ofertas-practicas-tutor') {
            router.push(this.linkBack + row.idOferta)
          }
          else {
            router.push(this.linkBack + row.idPractica)
          }

        } else {
          if (this.$route.name == 'aprobaciones') {
            router.push(`${this.$route.meta.indexPath}/${row.urlAcceso}`);
          }
          else {
            router.push(`${this.$route.meta.indexPath}/${row.idPractica}`);
          }
        }
      }
    },
    exportExcel() {
      let data = XLSX.utils.json_to_sheet(this.listadopracticas);
      const workbook = XLSX.utils.book_new();
      const date = new Date();
      const filename = String(`${date.getDay()}-${date.getMonth() + 1}-${date.getFullYear()} - Listado prácticas`);
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    setListadoAniosAcademicos() {
      if (this.idAnioAcademicoHistorico == null) {
        const anioActual = Array.isArray(this.aniosAcademicos)
          ? this.aniosAcademicos.find(a => a && a.anioActual === true)
          : null;
        if (anioActual) {
          this.idAnioAcademicoHistorico = anioActual.clave;
        }
      }

    },
    anioAcademicoHistoricoChange() {
      if (this.idAnioAcademicoHistorico != -1) {
        this.requestTutoradasHistorico(this.idAnioAcademicoHistorico);
      }
    },
    ...mapActions(['toggleFavoritos', 'requestTutoradasHistorico'])
  },
  computed: {
    ...mapGetters({
      styles: 'getStyles',
      colors: 'basicColors',
      validaciones: 'getValidaciones',
      validacionesPorEstados: 'getValidacionesPorEstados',
      tutoradas: 'getTutoradas',
      aprobaciones: 'getAprobaciones',
      aprobacionesporEstados: 'getAprobacionesPorEstados',
      tutoradasPorEstados: 'getTutoradasPorEstados',
      favoritos: 'getFavoritos',
      getEncabezados: 'getEncabezados',
      textos: 'getTexts',
      ofertasTutores: 'getOfertasTutores',
      loading: 'getLoading',
      aniosAcademicos: 'getAniosAcademicos'
    }),
    linkBack: function () {
      if (this.$route.name == 'ofertas-practicas-tutor') {
        return `/ofertas/`;
      }
      else {
        return `${this.$route.meta.indexPath}/${(!Number(this.$route.params.status) > 0) ? this.$route.params.status : undefined}/`;
      }
    },
    dataSelected: function () {

      let selected = new Array();

      if (!!this.$route.params.status) {

        if (this.$route.name == 'validaciones') {
          if (!Object.keys(this.validacionesPorEstados).find((ele) => ele === this.$route.params.status)) {
            selected = this.validaciones;
          } else {
            selected = (!!this.$route.params.status) ? this.validacionesPorEstados[this.$route.params.status] : this.validaciones;
          }
        } else if (this.$route.name == 'tutorados') {
          if (!Object.keys(this.tutoradasPorEstados).find((ele) => ele === this.$route.params.status)) {
            selected = this.tutoradas;
          } else {
            selected = (!!this.$route.params.status) ? this.tutoradasPorEstados[this.$route.params.status] : this.tutoradas;
          }
        } else if (this.$route.name == 'aprobaciones') {
          if (!Object.keys(this.aprobacionesporEstados).find((ele) => ele === this.$route.params.status)) {
            selected = this.aprobaciones;
          } else {
            selected = (!!this.$route.params.status) ? this.aprobacionesporEstados[this.$route.params.status] : this.aprobaciones;
          }
        }


      } else {

        if (this.$route.name == 'validaciones') {
          selected = this.validaciones;
        } else if (this.$route.name == 'tutorados') {
          selected = this.tutoradas;
        } else if (this.$route.name == 'aprobaciones') {
          selected = this.aprobaciones;
        }
        else if (this.$route.name == 'ofertas-practicas-tutor') {
          selected = this.ofertasTutores;
        }


      }

      (!!!selected) ? selected = [] : null;

      return selected;
    },
    listadopracticas() {
      if (!!this.dataSelected) {
        let pr = {}
        let practicas = [];
        this.dataSelected.forEach(c => {
          pr = {};
          Object.entries(this.columsExcel).forEach(ec => {
            pr[ec[1]] = c[ec[0]];
          })
          practicas.push(pr);
        });
        return practicas;
      }
    },
  },
  components: {
    'column-setter': columnSetter,
    'next': next,
    'fav': fav,
    'columnas': columnas,
    'excel': excel,
    'loading': loading
  },
  data() {
    return {
      showColumnasSetter: false,
      selected: {},
      encabezados: {},
      columns: [],
      columsExcel: [],
      options: {
        skin: 'table',
        highlightMatches: true,
        headings: {},
        texts: {
          filter: "Buscar:",
          filterBy: 'Filtrar por {column}',
          count: '',
          records: 'Resultados',
          limit: "Por Página: ",
          page: "Págína:",
          noResults: "No se han encontrado resultados",
          filterPlaceholder: "Escribe para buscar",
        },
        dateFormat: 'DD-MM-YY',
        perPage: 10,
        resizableColumns: true,
        perPageValues: [10, 20, 30, 50],
        columnsClasses: {},
        sortIcon: {
          is: 'glyphicon-sort',
          base: 'glyphicon',
          up: 'fa fa-angle-up',
          down: 'fa fa-angle-down'
        },
        rowClassCallback(row, $route) {
          let lastParam = window.location.pathname.split("/").pop();
          return (row.idPractica == lastParam) ? 'selected' : '';
        }
      },
      tableData: [],
      idAnioAcademicoHistorico: null
    }
  },
  filters: {
    parsedate(value) {
      let date = value.split(" ")[0].split("/");
      date = new Date(date[2], date[1] - 1, date[0]);
      moment.locale('es');
      return moment(date).format('L')
    }
  },
  watch: {
    '$route': function () {
      this.setColumnas();
    },
    'showColumnasSetter': function () {
      this.setColumnas();
    },
    '$route.params.status': {
      handler(newVal) {
        if (this.aniosAcademicos) {
          this.setListadoAniosAcademicos();
          this.anioAcademicoHistoricoChange()
        }
      },
      immediate: true
    },
    '$route.params.id': {
      handler(newVal) {
        if (this.aniosAcademicos) {
          this.anioAcademicoHistoricoChange()
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.ficha-title {
  margin-top: 0;
  margin-bottom: 0;
  width: auto;
}

.toggle-todo {
  position: absolute;
  left: 10px;
  top: 47px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background: #d8d8d8;
  font-size: 12px;
  color: #4a4a4a;
}

.contenedor-tabla {
  width: 100%;
  min-height: 100%;
  display: inline-block;
}

.contenedor-opciones {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

.option-table {
  text-transform: uppercase;
  font-size: 9px;
  text-align: center;
  padding: 0 10px;
  position: relative;
}

.column {
  width: 30px;
  height: 30px;
  position: relative;
  margin-bottom: 10px;

  svg {
    width: 40px;
  }
}

.to-ficha {
  width: 10px;
  height: 20px;
  display: inline-block;
  font-size: 0;

  svg {
    width: 10px;
    height: 20px;
  }
}


.checkbox-cell {
  min-width: 65px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/contenedor-tabla.vue